import { Injectable } from '@angular/core';
import { Observable, throwError, BehaviorSubject, Subject } from 'rxjs';
import { MenuItem } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Constants, CRUMBS } from '../../_utility';

@Injectable({
  providedIn: 'root',
})
export class BreadcrumbsService {
  private crumbs: Subject<MenuItem[]>;
  crumbs$: Observable<MenuItem[]>;

  constructor(
    private translate: TranslateService,
    private router: Router,
    private route: ActivatedRoute
  ) {
    this.crumbs = new Subject<MenuItem[]>();
    this.crumbs$ = this.crumbs.asObservable();
    this.translate.onLangChange.subscribe({
      next: () => {
        const currentPath = this.router.url.split('?')[0].replace('/', '');
        this.setCrumbs(currentPath);
      },
    });
  }

  setCrumbs(index: string) {
    let items = CRUMBS[index];
    const translatedItems = items.map((item) => ({
      ...item,
      label: this.translate.instant(item.label!),
      routerLinkActiveOptions: { exact: true },
    }));

    this.crumbs.next(translatedItems);
  }
}
